import { UserInfo } from '~/shared/types/user.ts'

export const getFullName = (user?: Pick<UserInfo, 'firstName' | 'lastName'>): string => {
  const firstName = user?.firstName || ''
  const lastName = user?.lastName || ''
  return `${firstName} ${lastName}`.trim()
}